import { render, staticRenderFns } from "./LayersList.vue?vue&type=template&id=0873e5f8&scoped=true"
import script from "./LayersList.vue?vue&type=script&lang=js"
export * from "./LayersList.vue?vue&type=script&lang=js"
import style0 from "./LayersList.vue?vue&type=style&index=0&id=0873e5f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873e5f8",
  null
  
)

export default component.exports